module.exports = __webpack_public_path__ + "static/media/wordsapp.924f9ca1.webp";